module.exports = __webpack_public_path__ + "img/ic-horizontal-christmas.43bdb800.svg";